
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/async",
      function () {
        return require("private-next-pages/async.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/async"])
      });
    }
  